import { selectMany } from "@client/lib/array";
import { MegaMenuSortingType, type MenuItem } from "@client/types";
import { type Grid } from "@client/types/Grid";
import { type MegaItemProps } from "./component";

export type GridMenuItem = MenuItem & {
  isDirectChild: boolean;
};

export interface MegaItemGridColumn {
  className: string;
  items: Array<GridMenuItem>;
}

export const getGrid = (opts: MegaItemProps): Grid<MegaItemGridColumn> => {
  const mmo = opts.item.megaOptions!;
  const grid: Grid<MegaItemGridColumn> = {
    rows: []
  };

  if (!opts.item.children || !opts.item.children.length) return grid;

  let noOfColumns = 12 / mmo.columns;

  let allChildren = selectMany<MenuItem>(opts.item.children, "children");

  let noOfAllChildren = allChildren.length;
  let noOfItemsPerColumn = (noOfAllChildren - (noOfAllChildren % noOfColumns)) / noOfColumns;

  if (noOfColumns < 1) noOfColumns = 5;

  if (mmo.sorting === MegaMenuSortingType.List) {
    if (noOfAllChildren % noOfColumns !== 0) noOfItemsPerColumn++;

    const columns: MegaItemGridColumn[] = [];
    for (let i = 0; i < noOfAllChildren; i += noOfItemsPerColumn) {
      const children = allChildren.slice(i, i + noOfItemsPerColumn);

      columns.push({
        className: `col-md-${mmo.columns}`,
        items: children.map((ch) => ({ ...ch, isDirectChild: ch.parentId === opts.item.id }))
      });
    }

    grid.rows.push({ columns });
  }

  if (mmo.sorting === MegaMenuSortingType.Parent) {
    for (let i = 0; i < opts.item.children.length; i += noOfColumns) {
      grid.rows.push({
        columns: opts.item.children.slice(i, i + noOfColumns).map((child) => ({
          className: `col-md-${mmo.columns}`,
          items: [
            { ...child, isDirectChild: true },
            ...(child.children
              ? selectMany<MenuItem>(child.children, "children").map((c) => ({ ...c, isDirectChild: false }))
              : [])
          ]
        }))
      });
    }
  }

  return grid;
};
